import React, { useContext } from "react";

import "./About.css";
import { ThemeContext } from "../../contexts/ThemeContext";
import { aboutProfessionalData } from "../../data/aboutProfessionalData";
import { aboutPrivateData } from "../../data/aboutPrivateData";

function About() {
  const { theme } = useContext(ThemeContext);
  return (
    <div
      className="about"
      id="about"
      style={{ backgroundColor: theme.secondary }}
    >
      <div className="line-styling">
        <div
          className="style-circle"
          style={{ backgroundColor: theme.primary }}
        ></div>
        <div
          className="style-circle"
          style={{ backgroundColor: theme.primary }}
        ></div>
        <div
          className="style-line"
          style={{ backgroundColor: theme.primary }}
        ></div>
      </div>
      <div className="about-body">
        <div className="about-description">
          <h2 style={{ color: theme.primary }}>
            {aboutProfessionalData.title}
          </h2>
          <p style={{ color: theme.tertiary80 }}>
            {aboutProfessionalData.description1}
            <br />
            <br />
            {aboutProfessionalData.description2}
            <br />
            <br />
            {aboutProfessionalData.description3}
            <br />
            <br />
          </p>
        </div>
        <div className="about-img">
          <img src={aboutProfessionalData.image} alt="aboutProfessionalData" />
        </div>
      </div>
      <div className="about-body">
        <div className="about-img">
          <img src={aboutPrivateData.image} alt="aboutPrivateData" />
        </div>
        <div className="about-description">
          <h2 style={{ color: theme.primary }}>{aboutPrivateData.title}</h2>
          <p style={{ color: theme.tertiary80 }}>
            {aboutPrivateData.description1}
            <br />
            <br />
            {aboutPrivateData.description2}
            <br />
            <br />
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
